/**
 * Created by jonas on 2020-08-14.
 */

import {IMentalGameData} from "./MentalData";
import {ArrayUtils} from "../utils/ArrayUtils";
import {MentalGameMode} from "./MentalGameMode";

export enum ReelEnhancer {
    NONE = "",
    XWAYS = "X_WAYS",
    XSPLIT = "X_SPLIT",
    XNUDGE_WILDS = "X_NUDGE_WILD",
    FIRE_FRAMES = "FIRE_FRAMES",
    X_WAYS_WILD = "X_WAYS_WILD",
    WILD_DROP = "WILD_DROP",
}

export class ReelEnhancerData {
    public _fireFrameOnReels: boolean[][] = []; // all positions
    public isFireFrame: boolean[] = [false, false, false, false, false]; // reel specific

    // public xWaySymbolPositions: number[];
    public xWaysPossibleReels: number[] = [1, 3]; // possibleXWaysReel
    public xSplitPositions: boolean[][] = [];
    private _enhancerData: IMentalGameData;

    constructor(data: IMentalGameData) {
        this._enhancerData = data;
        this.xSplitPositions = ArrayUtils.initArrayWithValues<boolean[]>(5, () => {
            return ArrayUtils.initArrayWithValues<boolean>(3, () => false)
        });

        this.fireFramesDataParsing(data);
    }

    private fireFramesDataParsing(data: IMentalGameData): void {
        this._fireFrameOnReels = data.mode !== MentalGameMode.NORMAL ? data.stickyFires : data.fireFrames;
        for (let reelId: number = 0; reelId < 5; reelId++) {
            this.isFireFrame[reelId] = !!(this._fireFrameOnReels[reelId].filter(value => value).length);
        }
    }
}